import { getCompetitionResults } from "../../../api";

export const fetchCompetitionResults = async ({
  discipline,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  day = null,
  groupKey = null,
}) => {
  const { data } = await getCompetitionResults({
    discipline,
    competitionIds,
    season,
    widgetConfigurationId,
    day,
    groupKey,
  });

  return data;
};